import { defineComponent as _defineComponent } from 'vue'
import HorizontalTitleListGraphql from '@/components/timeline/HorizontalTitleListGraphql.vue';

import { ImpressionTrackingEvents } from '@/enums/events';
import { TrackingProviderPropertiesInterface } from '@/helpers/tracking/providers';

import { SnowplowContext } from '@/helpers/tracking/providers/snowplow-contexts';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';

import type { SimilarTitle } from '@/interfaces/title-details-graphql';
import type { SponsoredAdFragmentFragment } from '@/pages/graphql/fragments/SponsoredAd.fragment';


export default /*#__PURE__*/_defineComponent({
  __name: 'SRTitleListGraphql',
  props: {
    fullWidth: { type: Boolean },
    titles: null,
    sponsoredAd: null,
    additionalContexts: null,
    impressionTrackingLabel: null,
    impressionTrackingProperty: null,
    impressionTrackingCategory: null,
    showSponsoredAd: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
	fullWidth: boolean;
	titles: SimilarTitle[];
	sponsoredAd: SponsoredAdFragmentFragment | null;
	additionalContexts?: SnowplowContext[];
	impressionTrackingLabel?: string;
	impressionTrackingProperty?: string;
	impressionTrackingCategory?: any;
	showSponsoredAd: boolean;
}



// Note(valerio.mazza): SSR special case we need to track the Event on created
if (process.server && props.titles?.length) {
	trackSimilarTitlesLoaded();
}

function trackSimilarTitlesLoaded() {
	const properties: TrackingProviderPropertiesInterface = { action: 'loaded', nonInteraction: true };
	if (props.impressionTrackingLabel) properties.label = props.impressionTrackingLabel;

	TrackingHelper.trackEvent(ImpressionTrackingEvents.SPONSORED_RECOMMENDATIONS, properties, props.additionalContexts);
}

function trackScroll(label: string) {
	const properties: TrackingProviderPropertiesInterface = { action: 'horizontal_scroller_clicked', label };
	if (props.impressionTrackingLabel) properties.property = props.impressionTrackingLabel;

	TrackingHelper.trackEvent('userinteraction', properties, props.additionalContexts);
}

return { __sfc: true,props, trackSimilarTitlesLoaded, trackScroll, HorizontalTitleListGraphql }
}

})